import { useState } from 'react';
import './LoginPage.css';

function LoginForm({ onLoginSuccess, apiBase }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'email') setEmail(value);
    if (name === 'password') setPassword(value);
    if (error) setError('');
  };

  async function handleLogin(e) {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Please fill in all fields');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);

    try {
      const staffLoginUrl = `${apiBase}/auth/login`;
      const parentLoginUrl = `${apiBase}/admissions/login`;
      
      console.log('[LoginForm] Staff login URL:', staffLoginUrl);
      console.log('[LoginForm] Parent login URL:', parentLoginUrl);
      
      // Try staff login first
      try {
        console.log('[LoginForm] Attempting staff login with email:', email);
        const response = await fetch(staffLoginUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ email, password }),
        });

        console.log('[LoginForm] Staff login response status:', response.status, response.statusText);
        
        if (response.ok) {
          const data = await response.json();
          console.log('[LoginForm] Staff login response:', data);
          
          if (data.ok) {
            console.log('[LoginForm] Staff login successful');
            onLoginSuccess({
              type: 'staff',
              user: data.data.user,
            });
            return;
          }
        }
      } catch (staffError) {
        console.log('[LoginForm] Staff login error:', staffError.message);
      }

      // Try parent (admissions) login
      try {
        console.log('[LoginForm] Attempting parent login with email:', email);
        const response = await fetch(parentLoginUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ email: email.toLowerCase(), password }),
        });

        console.log('[LoginForm] Parent login response status:', response.status, response.statusText);
        
        if (response.ok) {
          const data = await response.json();
          console.log('[LoginForm] Parent login response:', data);
          
          if (data.ok) {
            console.log('[LoginForm] Parent login successful');
            onLoginSuccess({
              type: 'parent',
              user: data.data.user,
            });
            return;
          }
        }
      } catch (parentError) {
        console.log('[LoginForm] Parent login error:', parentError.message);
      }

      // Both failed
      console.log('[LoginForm] Both login types failed');
      setError('Invalid email or password');
    } catch (err) {
      console.error('[LoginForm] Unexpected error:', err);
      setError('An error occurred: ' + (err.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <button type="button" className="back-button-fixed" onClick={() => window.location.href = '/'}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M19 12H5"/>
          <path d="M12 19l-7-7 7-7"/>
        </svg>
        <span>Back to Homepage</span>
      </button>

      {error && (
        <div className="error-toast-modern">
          <div className="error-toast-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          <div className="error-toast-text">
            <strong>Login Failed</strong>
            <p>{error}</p>
          </div>
          <button type="button" className="error-toast-close" onClick={() => setError('')}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
      )}

      <div className="login-container">
        <div className="login-header">
          <div className="login-brand">
            <img src="/logo_phs.png" alt="PHS Logo" className="login-logo" />
            <div className="login-brand-text">
              <h1>Welcome Back</h1>
              <p>Sign in to your account</p>
            </div>
          </div>
        </div>

        <form className="login-form" onSubmit={handleLogin}>
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-input"
                value={email}
                onChange={handleInputChange}
                placeholder="Enter your email address"
                required
                disabled={loading}
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password *</label>
              <input
                type="password"
                id="password"
                name="password"
                className="form-input"
                value={password}
                onChange={handleInputChange}
                placeholder="Enter your password"
                required
                disabled={loading}
                autoComplete="current-password"
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="login-submit-btn"
            disabled={loading}
          >
            {loading ? (
              <>
                <svg className="spinner" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="3"/>
                </svg>
                Signing In...
              </>
            ) : (
              'Sign In'
            )}
          </button>

          <div className="login-footer">
            <button type="button" className="register-link" onClick={() => {
              window.location.hash = '#register';
              window.location.reload();
            }}>
              Don't have an account? Create one
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
